import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4"
}

import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'TreeViewItem',
  props: {
    item: {},
    path: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const route = useRoute();

const isActive = computed(() => {
  return route.path.includes(props.item.id);
});

const navigateToItem = () => {
  const newPath = [...props.path, props.item.id].join('/');
  router.push(`/help/${newPath}`);
};

return (_ctx: any,_cache: any) => {
  const _component_TreeItem = _resolveComponent("TreeItem")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", {
      onClick: navigateToItem,
      class: _normalizeClass({
        'font-bold': _ctx.item.children,
        'cursor-pointer': true,
        'hover:text-blue-600': true,
        'text-blue-600': isActive.value
      })
    }, _toDisplayString(_ctx.item.title), 3),
    (_ctx.item.children)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
            return (_openBlock(), _createBlock(_component_TreeItem, {
              key: child.id,
              item: child,
              path: [..._ctx.path, _ctx.item.id]
            }, null, 8, ["item", "path"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})